import { create } from 'zustand';

import { EnrichedCustomer } from '@/models/enriched-prismic-documents.ts';

const initialState: { customers: EnrichedCustomer[]; instance_colors: Record<string, string> } = {
    customers: [],
    instance_colors: {},
};

export const usePrismicStore = create<{
    customers: EnrichedCustomer[];
    instance_colors: Record<string, string>;
    reset: () => void;
}>((set) => ({
    ...initialState,
    reset: (): void => set({ ...initialState }),
}));
